var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Lang } from '@debbie/common/dist/lang';
import { setToken } from './auth/actions';
import { select as selectCreditor } from './creditors/actions';
import { select as selectExclusiveContent } from './exclusiveContent/actions';
import { setDispatch, populateInternal, authToken, selectedCreditorId, selectedOwnerIds, exclusiveContent, currentLang, } from './internal';
import { setLang } from './lang/actions';
import { select as selectTenantId } from './selectedOwners/actions';
import { init } from './socket';
import store from './store';
export const Provider = (props) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    React.useEffect(() => {
        const loadApp = () => __awaiter(void 0, void 0, void 0, function* () {
            setDispatch(store.dispatch);
            yield populateInternal();
            authToken && authToken.length > 0 && setToken(authToken);
            selectedCreditorId && selectCreditor(selectedCreditorId);
            selectedOwnerIds.length > 0 && selectTenantId(selectedOwnerIds[0]);
            (exclusiveContent === null || exclusiveContent === void 0 ? void 0 : exclusiveContent.length) > 0 && selectExclusiveContent(exclusiveContent);
            setLang(currentLang || Lang.da);
            if (authToken && selectedOwnerIds[0]) {
                init(authToken, selectedOwnerIds[0]);
            }
            setIsLoaded(true);
        });
        loadApp();
    }, []);
    return ((isLoaded && (React.createElement(ReduxProvider, { store: store }, props.children))) || React.createElement(React.Fragment, null));
};
export default Provider;
//# sourceMappingURL=Provider.js.map